import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import ActiveSwitchFile from "../../components/SwitchFile";
import DeletePop from "../../constants/ErrorPermissionModal";

const vesselMap = {
  1: "Genting Dream",
  2: "Star Navigator",
  3: "Star Voyager",
};

function splitDateTime(datetime) {
  if (!datetime) return { date: "-", time: "-" };
  
  let dateStr = datetime.toString();
  
  if (dateStr.includes('T')) {
    const [datePart, timePart] = dateStr.split('T');
    const [year, month, day] = datePart.split('-');
    const timeOnly = timePart.split('.')[0];
    
    const date = `${day}/${month}/${year}`;
    const time = timeOnly;
    
    return { date, time };
  } else if (dateStr.includes(' ')) {
    const [datePart, timePart] = dateStr.split(' ');
    const [year, month, day] = datePart.split('-');
    
    const date = `${day}/${month}/${year}`;
    const time = timePart;
    
    return { date, time };
  } else {
    return { date: dateStr, time: "-" };
  }
}

export default function CurrencyTable({
  rows,
  onEdit,
  onDelete,
  handleUpdate,
}) {
  // Group rows by vessel_id
  const groupedRows = rows.reduce((acc, row) => {
    if (!acc[row.vessel_id]) acc[row.vessel_id] = [];
    acc[row.vessel_id].push(row);
    return acc;
  }, {});

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
          <TableRow>
            <TableCell>
              <Typography fontWeight="bold">Ship</Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight="bold" >
                Currency
              </Typography>
            </TableCell>
            <TableCell align="center" colSpan={2}>
              <Typography fontWeight="bold">Effective Start</Typography>
            </TableCell>
            <TableCell align="center" colSpan={2}>
              <Typography fontWeight="bold">Effective End</Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight="bold">Status</Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight="bold">Actions</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell />
            <TableCell />
            <TableCell>Date</TableCell>
            <TableCell>Time</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Time</TableCell>
            <TableCell />
            <TableCell />
          </TableRow>
        </TableHead>

        <TableBody>
          {Object.entries(groupedRows).map(([vessel_id, vesselRows]) =>
            vesselRows.map((row, index) => {
              const { date: startDate, time: startTime } = splitDateTime(
                row.from_date
              );
              const { date: endDate, time: endTime } = splitDateTime(
                row.to_date
              );

              return (
                <TableRow key={row.id}>
                  {index === 0 && (
                    <TableCell
                      rowSpan={vesselRows.length}
                      sx={{ verticalAlign: "middle" }}
                    >
                      <Typography fontWeight="bold">
                        {vesselMap[vessel_id] || "Unknown Ship"}
                      </Typography>
                    </TableCell>
                  )}
                  <TableCell>{row.currency}</TableCell>
                  <TableCell>{startDate}</TableCell>
                  <TableCell>{startTime}</TableCell>
                  <TableCell>{endDate}</TableCell>
                  <TableCell>{endTime}</TableCell>
                  <TableCell>
                     <ActiveSwitchFile
                        item={row.is_active}
                        record={row}
                        index={row.id}
                        handleUpdate={handleUpdate}
                      />
                  </TableCell>
                  <TableCell>
                    <Box display="flex" gap={1}>
                      <IconButton
                        size="small"
                        sx={{
                          backgroundColor: "#f5deb3",
                          borderRadius: 1,
                          '&:hover': { backgroundColor: "#f5deb3" }
                        }}
                        onClick={() => onEdit?.(row.id)}
                      >
                        <Edit fontSize="small" />
                      </IconButton>
                      <DeletePop
                        title={`Delete Currency ${row.currency}`}
                        onConfirm={() => onDelete?.(row.id, row.currency, vesselMap[vessel_id])}
                      >
                        <IconButton
                          size="small"
                          sx={{
                            backgroundColor: "#d32f2f",
                            color: "white",
                            borderRadius: 1,
                            '&:hover': { backgroundColor: "#d32f2f" }
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </DeletePop>
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
